(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/regenerator", "@babel/runtime/helpers/asyncToGenerator", "@babel/runtime/helpers/extends", "@h3yun/domain", "@h3yun/sdk-core", "@h3yun/request", "@h3yun/global-provider"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/regenerator"), require("@babel/runtime/helpers/asyncToGenerator"), require("@babel/runtime/helpers/extends"), require("@h3yun/domain"), require("@h3yun/sdk-core"), require("@h3yun/request"), require("@h3yun/global-provider"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.regenerator, global.asyncToGenerator, global._extends, global.domain, global.sdkCore, global.request, global.globalProvider);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _regenerator, _asyncToGenerator2, _extends2, _domain, _sdkCore, _request, _globalProvider) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  _exports.__esModule = true;
  var _exportNames = {
    globalRouter: true,
    injectRefreshTokenIFrame: true,
    refreshTokenMiddleware: true,
    setGlobal: true,
    useGlobal: true,
    useModou: true,
    useRefs: true,
    useSchemaContext: true,
    useScope: true,
    request: true
  };
  _exports.injectRefreshTokenIFrame = injectRefreshTokenIFrame;
  _exports.refreshTokenMiddleware = refreshTokenMiddleware;
  _exports.setGlobal = setGlobal;
  _exports.useGlobal = useGlobal;
  _exports.useModou = useModou;
  _exports.useRefs = useRefs;
  _exports.useSchemaContext = useSchemaContext;
  _exports.useScope = useScope;
  _exports.globalRouter = void 0;
  _regenerator = _interopRequireDefault(_regenerator);
  _asyncToGenerator2 = _interopRequireDefault(_asyncToGenerator2);
  _extends2 = _interopRequireDefault(_extends2);
  Object.keys(_domain).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in _exports && _exports[key] === _domain[key]) return;
    _exports[key] = _domain[key];
  });
  Object.keys(_sdkCore).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in _exports && _exports[key] === _sdkCore[key]) return;
    _exports[key] = _sdkCore[key];
  });
  _request = _interopRequireWildcard(_request);
  _exports.request = _request.request;

  _request.request.interceptors.request.use(function (url, options) {
    var optionsHeaders = (options == null ? void 0 : options.headers) || {};
    var presetKeys = ['X-H3-EngineCode', 'X-H3-MemberId', 'X-App-Name', 'X-App-Version', 'X-Engine-Shard', 'X-GUID'];
    var headers = {};
    presetKeys.forEach(function (key) {
      var value = key in optionsHeaders ? optionsHeaders[key] : _globalProvider.globalStorage.get(key) || '';

      if (value) {
        headers[key] = value;
      }

      if (key in optionsHeaders) {
        delete optionsHeaders[key];
      }
    }); // 保留从本地获取X-H3-Token的功能，支持app端

    if (typeof window !== 'undefined') {
      var localToken = window.localStorage.getItem('X-H3-Token') || '';

      if (localToken) {
        optionsHeaders['X-H3-Token'] = localToken;
      }
    }

    Object.assign(headers, optionsHeaders);
    return {
      url: url,
      options: (0, _extends2["default"])({}, options, {
        headers: headers
      })
    };
  }, {
    global: true
  }); // 插入刷新token的iframe方法


  function injectRefreshTokenIFrame(refreshTokenUrl) {
    return new Promise(function (resolve) {
      var origin = window.location.origin; // 支持本地开发，本地需要代理/refreshToken.html

      if (origin.indexOf('localhost') > -1 || /\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}/.test(origin)) {
        refreshTokenUrl = origin + '/refreshToken.html';
      } // 拼接参数使用?还是&


      var paramPrefix = refreshTokenUrl.indexOf('?') > -1 ? '&' : '?';
      var iframe = document.createElement('iframe');
      iframe.id = 'refresh_token_iframe';
      iframe.src = refreshTokenUrl + paramPrefix + 'v=v2';
      iframe.style.display = 'none';

      function loaded(event) {
        var payload = event.data || {}; // 当收到了一次postMessage消息，说明iframe运行正常

        if (payload.message === 'refreshToken') {
          window.removeEventListener('message', loaded);
          resolve({
            iframe: iframe,
            payload: payload
          });
        } // 10秒没返回，说明iframe不正常


        setTimeout(function () {
          window.removeEventListener('message', loaded);
          resolve(false);
        }, 10000);
      }

      window.addEventListener('message', loaded); // 最后插入

      document.body.appendChild(iframe);
    });
  } // 添加刷新token拦截器


  function refreshTokenMiddleware(injectIframeResult) {
    var _injectIframeResult$p;

    // iframe插入未成功，后续不执行
    if (!injectIframeResult) {
      return;
    }

    var version = (_injectIframeResult$p = injectIframeResult.payload) == null ? void 0 : _injectIframeResult$p.version; // html存在缓存为旧版本，不启用功能

    if (!version || version < 'v2') {
      return;
    }

    var iframeRef = injectIframeResult.iframe; // 单例promise

    var tokenValidPromise = Promise.resolve(); // 繁忙

    var promisePedding = false; // token过期时间

    var tokenExpiration = 0; // 监听iframe发过来的事件

    function addRefreshTokenMessageListener() {
      window.addEventListener('message', function (event) {
        var payload = event.data || {};

        if (payload.message === 'refreshToken' && payload.result === 'success') {
          // 监听版本变化
          if (payload.data && payload.data.versionChanged) {
            _globalProvider.globalStorage.setToLocal('versionChanged', true);
          } // 更新过期时间


          if (payload.expiration) {
            tokenExpiration = payload.expiration;
          }
        }
      });
    } // 刷新token操作


    function refreshToken() {
      // 繁忙
      if (promisePedding) {
        return tokenValidPromise;
      }

      return new Promise(function (resolve) {
        promisePedding = true; // 完成事件

        function finished(event) {
          var payload = event.data || {};

          if (payload.message === 'refreshToken') {
            window.removeEventListener('message', finished);
            promisePedding = false;
            resolve(payload);
          }
        }

        window.addEventListener('message', finished); // 发送请求

        iframeRef.contentWindow.postMessage({
          message: 'checkToken'
        }, '*');
      });
    } // 添加监听


    addRefreshTokenMessageListener();
    /** 请求阶段 */

    _request.request.use( /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(ctx, next) {
        var timing;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // 过期时间前n毫秒(目前为5分钟)
                timing = 5 * 60000; // 达到过期前timing

                if (!(tokenExpiration && tokenExpiration - Date.now() < timing)) {
                  _context.next = 5;
                  break;
                }

                tokenValidPromise = refreshToken();
                _context.next = 5;
                return tokenValidPromise;

              case 5:
                _context.next = 7;
                return next();

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }(), {
      global: true
    });
  }
  /**
   * ModouReferences
   */


  var ModouReferences = /*#__PURE__*/function () {
    function ModouReferences() {}

    var _proto = ModouReferences.prototype;

    _proto.register = function register(key, ref) {
      Object.defineProperty(this, key, {
        get: function get() {
          return ref;
        },
        configurable: true
      });
      return this;
    };

    _proto.unregister = function unregister(key) {
      return delete this[key];
    };

    return ModouReferences;
  }();
  /**
   * @packageDocumentation
   * @module opensdk.api
   */

  /**
   * @hidden
   */


  var ModouDomainBaseKey = 'ModouDomainBase';
  /**
   * @hidden
   */

  var modouGlobalKey = 'ModouGlobalScope';
  /**
   * @hidden
   */

  var modouGlobalOptionsKey = 'ModouGlobalScopeOptions';
  /**
   * @hidden
   */

  var modouGlobalRefsKey = 'ModouGlobalRefs';
  /**
   * @hidden
   * @deprecated 请使用this.$modou.router
   */

  var globalRouter = null;
  _exports.globalRouter = globalRouter;

  function createBaseMap(initOptions) {
    if (!initOptions) {
      throw new Error('缺少初始化创建参数');
    }

    var UserContext = initOptions.UserContext,
        EngineContext = initOptions.EngineContext,
        AppContext = initOptions.AppContext,
        tempSchemaContext = initOptions.SchemaContext,
        ViewContext = initOptions.ViewContext;
    var User = _domain.domainDefinitionMap.User,
        Engine = _domain.domainDefinitionMap.Engine,
        Apps = _domain.domainDefinitionMap.Apps,
        Schemas = _domain.domainDefinitionMap.Schemas,
        Views = _domain.domainDefinitionMap.Views;
    var cacheStore = (0, _sdkCore.createCacheStore)();
    return {
      User: (0, _sdkCore.createDomainBase)(UserContext, User, cacheStore),
      Engine: (0, _sdkCore.createDomainBase)(EngineContext, Engine, cacheStore),
      Apps: (0, _sdkCore.createDomainBase)(AppContext, Apps, cacheStore),
      Schemas: (0, _sdkCore.createDomainBase)(tempSchemaContext, Schemas, cacheStore),
      Views: (0, _sdkCore.createDomainBase)(ViewContext, Views, cacheStore),
      Caches: {
        store: cacheStore
      }
    };
  }
  /**
   * 全局初始化方法，传入配置，创建并设置全局Scope；注意全局设置只能生效一次；
   * 或者参数传空，返回全局Scope;
   *
   * ``` js
   * // 初始化定义
   * const modou = useModou({
   *    UserContext: {
   *      name: 'UserContext',
   *      domain: 'Users',
   *      actions: {
   *        getEngines() {
   *          // 具体实现代码
   *        }
   *      }
   *    }
   * });
   *
   *
   *
   * // 参数传空， 获取引用
   * const { UserContext } = useModou();
   * UserContext.getEngines();
   *
   * ```
   *
   * @param initOptions
   */


  function useModou(initOptions) {
    var globalScope = useGlobal(); // 做全局scope的校验
    // 注意在浏览器上，初始化只能一次
    // 在服务端渲染时，因为同一进程不重启globalStorage不清空，所以每次都需要重新初始化。防止状态单例

    if (globalScope) {
      // if (typeof window !== 'undefined') {
      //   throw new Error('Modou对象全局单例唯一');
      // }
      return globalScope;
    }

    if (!initOptions) {
      initOptions = {
        AppContext: _domain.AppContextImpl,
        EngineContext: _domain.EngineContextImpl,
        UserContext: _domain.UserContextImpl,
        SchemaContext: _domain.SchemaContextImpl,
        ViewContext: _domain.ViewContextImpl,
        middlewares: _domain.middlewares
      };
    } // 初始化进行中


    if (initOptions) {
      var baseMap = createBaseMap(initOptions);
      globalScope = (0, _sdkCore.createScope)(initOptions, baseMap); // const adaptors = initOptions?.adaptors || [];
      // adaptors.forEach((adaptor) => {
      //   globalScope[adaptor.name] = createAdaptorFactory(globalScope, adaptor.name, adaptor.apply);
      // });

      globalScope.set = function set(optionKey, option) {
        if (optionKey === 'router') {
          globalScope.router = (0, _sdkCore.createRouter)(option);
        } else if (optionKey === 'request') {
          globalScope.request = _request["default"];
        }

        return globalScope;
      };

      setGlobal(globalScope, baseMap, initOptions);
    } else {
      // 初次调用参数为空
      throw new Error('缺少初始化创建参数');
    } // 创建当前指针，标识当前状态


    return globalScope;
  }
  /**
   * @hidden
   */


  function useGlobal() {
    return _globalProvider.globalStorage.get(modouGlobalKey);
  }
  /**
   * @hidden
   */


  function setGlobal(scope, base, initOptions) {
    if (typeof window !== 'undefined') {
      _globalProvider.globalStorage.set(modouGlobalKey, scope);

      _globalProvider.globalStorage.set(modouGlobalOptionsKey, initOptions);

      _globalProvider.globalStorage.set(ModouDomainBaseKey, base);

      _exports.globalRouter = globalRouter = scope.router;
    }
  }
  /**
   * 根据传入参数创建创建局部scope；局部Scope包含独立的AppContext、SchemaContext和ViewContextß
   * 参数传空字符串则声明创建一个空的context，不进行load；
   * 创建的局部scope与全局scope的数据共享，但是实例不共享，所以记得自行进行销毁ß
   *
   *
   * ``` js
   * const scope = useScope({
   *    appCode: 'ap28123jk9',
   *    schemaCode: 'sm9j7bklpn',
   *    viewCode: 'vwkdkf9own',
   * });
   *
   *
   *
   * // 创建一个空的Scope
   *const scope = useScope({
     appCode: '',
     schemaCode: '',
     viewCode: '',
   });
   *
   * ```
   *
   * @param current.appCode 应用编码
   * @param current.schemaCode 数据表编码
   * @param current.viewCode 视图编码
   */


  function useScope(current) {
    if (current === void 0) {
      current = {};
    }

    var domainBase = _globalProvider.globalStorage.get(ModouDomainBaseKey);

    var globalOptions = _globalProvider.globalStorage.get(modouGlobalOptionsKey);

    var globalScope = _globalProvider.globalStorage.get(modouGlobalKey);

    if (domainBase && globalOptions && globalScope) {
      var scopeOptions = {
        UserContext: globalOptions.UserContext,
        EngineContext: globalOptions.EngineContext,
        AppContext: 'appCode' in current ? globalOptions.AppContext : undefined,
        SchemaContext: 'schemaCode' in current ? globalOptions.SchemaContext : undefined,
        ViewContext: 'viewCode' in current ? globalOptions.ViewContext : undefined
      };
      var scope = (0, _sdkCore.createScope)(scopeOptions, domainBase, globalScope);

      if (current.appCode) {
        scope.AppContext.load(current.appCode);
      }

      if (current.schemaCode) {
        scope.SchemaContext.load(current.schemaCode);
      }

      if (current.viewCode) {
        scope.ViewContext.load(current.viewCode);
      }

      return scope;
    }

    throw new Error('请先声明并创建全局Scope');
  }
  /**
   *
   * 根据指定的SchemaCode创建SchemaContext
   * AppContext 将继承parentScope上的AppContext
   *
   * ``` js
   * const SchemaContext = useSchemaContext('sm12345678');
   *
   * const views = SchemaContext.views;
   *
   * SchemaContext.unload(); // 用完了销毁
   * ```
   *
   * 这个独立的SchemaContext使用后记得调用unload方法销毁
   *
   * @param schemaCode 数据表编码
   * @param parentScope 用于继承的上级Scope，如果不传则使用全局Scope
   */


  function useSchemaContext(schemaCode, parentScope) {
    parentScope = parentScope || useGlobal();

    var domainBase = _globalProvider.globalStorage.get(ModouDomainBaseKey);

    var localScope = useScope();
    localScope.AppContext = parentScope.AppContext;
    localScope.SchemaContext = (0, _sdkCore.createContext)(parentScope, domainBase.Schemas);
    localScope.SchemaContext.load(schemaCode);
    return localScope.SchemaContext;
  }

  function useRefs(key) {
    var refs = _globalProvider.globalStorage.get(modouGlobalRefsKey);

    if (!refs) {
      refs = new ModouReferences();

      _globalProvider.globalStorage.set(modouGlobalRefsKey, refs);
    }

    if (key) {
      return refs[key];
    }

    return refs;
  }
});
